import {
  DeviceFamily,
  Placement,
  BusinessGroupId,
} from '@amzn/fire-tv-campaign-automation-service';
import { STAGE, ProvisionedConstants } from 'src/constants';

import { mergeConfig } from '../utils/ConfigUtils';

export type BusinessGroupIdConfig = Record<
  DeviceFamily,
  Partial<Record<Placement, BusinessGroupId[]>>
>;

const DEFAULT_CONFIG: BusinessGroupIdConfig = {
  [DeviceFamily.FIRE_TV]: {
    [Placement.FEATURE_ROTATOR]: [BusinessGroupId.Business_Group_Beta],
    [Placement.SCREEN_SAVER]: [BusinessGroupId.Business_Group_Beta],
  },
  [DeviceFamily.FIRE_TABLETS]: {
    [Placement.FEATURE_ROTATOR]: [BusinessGroupId.GW_DevicesTablet, BusinessGroupId.GW_Appstore],
  },
};

const STAGE_OVERRIDES: Partial<Record<STAGE, Partial<BusinessGroupIdConfig>>> = {
  [STAGE.GAMMA]: {
    [DeviceFamily.FIRE_TV]: {
      [Placement.FEATURE_ROTATOR]: [BusinessGroupId.Fire_TV],
      [Placement.SCREEN_SAVER]: [BusinessGroupId.Fire_TV],
    },
  },
  [STAGE.PROD_NA]: {
    [DeviceFamily.FIRE_TV]: {
      [Placement.FEATURE_ROTATOR]: [
        BusinessGroupId.Bullseye_Users,
        BusinessGroupId.FTV_Appstore_Marketing,
      ],
      [Placement.SCREEN_SAVER]: [
        BusinessGroupId.Bullseye_Users,
        BusinessGroupId.FTV_Appstore_Marketing,
      ],
    },
  },
  [STAGE.PROD_FE]: {
    [DeviceFamily.FIRE_TV]: {
      [Placement.FEATURE_ROTATOR]: [
        BusinessGroupId.Bullseye_Users,
        BusinessGroupId.FTV_Appstore_Marketing,
      ],
      [Placement.SCREEN_SAVER]: [
        BusinessGroupId.Bullseye_Users,
        BusinessGroupId.FTV_Appstore_Marketing,
      ],
    },
  },
};

const stage = process.env.NODE_ENV === 'test' ? STAGE.DEV : ProvisionedConstants.STAGE;

export const BUSINESS_GROUP_CONFIG: BusinessGroupIdConfig = mergeConfig(
  DEFAULT_CONFIG,
  STAGE_OVERRIDES[stage as STAGE],
);
